var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 16H16V496H496V16Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2146 200.13L123.367 126.402L74.2146 200.13ZM92.6467 212.418L141.799 138.69L92.6467 212.418ZM111.079 224.706L160.231 150.978Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111.079 224.706L160.231 150.978M74.2146 200.13L123.367 126.402L74.2146 200.13ZM92.6467 212.418L141.799 138.69L92.6467 212.418Z",
    stroke: "#222222",
    strokeWidth: 15
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M356.84 335.299L418.28 376.259Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M356.84 335.299L418.28 376.259",
    stroke: "white",
    strokeWidth: 7.3842
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M326.12 314.818C353.266 274.099 342.263 219.084 301.544 191.938C260.825 164.792 205.809 175.795 178.663 216.514C151.517 257.233 162.52 312.248 203.239 339.394C243.958 366.54 298.974 355.537 326.12 314.818Z",
    fill: "#E74C3C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M178.663 216.514C172.145 226.291 169.778 238.257 172.082 249.779C174.387 261.301 181.174 271.436 190.951 277.954C200.728 284.472 212.694 286.839 224.216 284.535C235.738 282.23 245.873 275.443 252.391 265.666C258.909 255.889 269.044 249.102 280.567 246.797C292.089 244.493 304.055 246.86 313.832 253.378C323.609 259.896 330.396 270.031 332.7 281.553C335.005 293.076 332.638 305.041 326.12 314.818C313.084 334.372 292.814 347.947 269.769 352.556C246.725 357.165 222.793 352.43 203.239 339.394C183.685 326.358 170.111 306.089 165.502 283.044C160.893 259.999 165.627 236.068 178.663 216.514V216.514Z",
    fill: "#356BA0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M108.007 361.923L126.439 349.635L108.007 361.923ZM356.84 196.034L378.344 181.698L356.84 196.034ZM396.776 169.41L415.208 157.122Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M396.776 169.41L415.208 157.122M108.007 361.923L126.439 349.635L108.007 361.923ZM356.84 196.034L378.344 181.698L356.84 196.034Z",
    stroke: "white",
    strokeWidth: 7.3842
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKr);
export default __webpack_public_path__ + "static/media/KR.650dc280c176b0a9d44a1f3f55a0b4d1.svg";
export { ForwardRef as ReactComponent };